import { AppShell, LibraryIcon, OverviewIcon, TasksIcon, type NavItem } from '@quoter/web-core'
import { useI18n } from '@/hooks/useI18n'
import type { Strings } from '@/i18n'

/** A function of `t`, not a module constant: it must re-render on a language switch. */
function navItems(t: Strings): NavItem[] {
  return [
    { to: '/', label: t.nav.today, icon: <OverviewIcon size={20} />, end: true },
    { to: '/foods', label: t.nav.foods, icon: <LibraryIcon size={20} /> },
    { to: '/plan', label: t.nav.plan, icon: <TasksIcon size={20} /> },
  ]
}

/** LowFodmaps's frame: the shared shell with three places to go. */
export function AppLayout() {
  const { t } = useI18n()
  return <AppShell nav={navItems(t)} />
}
